//存健康数据的全部数据列表
import { GET_FAMILY_HISTORY_DATA, SET_FAMILY_HISTORY_DATA, GET_DISEASE_LIST, } from "./actionType";

const defaultState = {
  diseaseList: { male: [{ name: "无", id: 0 }], female: [{ name: "无", id: 0 }] },//男女疾病列表
  familyHistory: { 205: [], 206: [], 207: [], 208: [], 209: [], 210: [], 211: [], 212: [] },//用于编辑的数据
  familyIndexHistory: { 205: [], 206: [], 207: [], 208: [], 209: [], 210: [], 211: [], 212: [] },//展示在首页的数据
};
const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case GET_FAMILY_HISTORY_DATA://存
      const getState = handleFamilyHistory (action.familyHistory, state);
      return { ...getState };
    case SET_FAMILY_HISTORY_DATA://设置
      return { ...state, ...action.params };
    case GET_DISEASE_LIST: //存病种
      const newAction = { ...action.params };
      const newState = { ...state };
      newState.diseaseList = { ...newState.diseaseList, ...newAction.diseaseList };
      return { ...state, ...newState };
    default:
      return state;
  }
};

//获取接口数据
const handleFamilyHistory = (action, state) => {
  const newState = { ...state };
  const newAction = [...action].sort ((a, b) => a.id - b.id);
  const obj = {};
  newAction.forEach ((i) => {
    obj[i.id] = i.data.is_operation ? (i.data.is_operation === 1 ? [{
      name: "无", id: 0, values: 0
    }] : [...i.data.list].map (item => ({
      name: item.element_name, id: item.element_id, values: item.values
    }))) : [];
  });
  newState.familyHistory = obj;
  newState.familyIndexHistory = obj;
  return newState;
};
export default Reducer;
